import { Field, InputType } from 'type-graphql'

// Provider-neutral billing prefill for hosted checkout (PayMongo's Customer Information
// form today). Every sub-field is optional — a missing value means the caller omits that
// key from the gateway payload entirely, never sends it blank.
@InputType()
export class CheckoutBilling {
  @Field(() => String, { nullable: true })
  name?: string

  @Field(() => String, { nullable: true })
  email?: string
}
